/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookingDetailApiResponse } from '../models/BookingDetailApiResponse';
import type { CancelBookingApiResponse } from '../models/CancelBookingApiResponse';
import type { CancelBookingDto } from '../models/CancelBookingDto';
import type { CancelSessionApiResponse } from '../models/CancelSessionApiResponse';
import type { CancelSessionDto } from '../models/CancelSessionDto';
import type { CreateFollowupApiResponse } from '../models/CreateFollowupApiResponse';
import type { CreateFollowupDto } from '../models/CreateFollowupDto';
import type { FetchClientSessionsApiResponse } from '../models/FetchClientSessionsApiResponse';
import type { FetchExpertClientsApiResponse } from '../models/FetchExpertClientsApiResponse';
import type { MarkAttendanceApiResponse } from '../models/MarkAttendanceApiResponse';
import type { MarkAttendanceDto } from '../models/MarkAttendanceDto';
import type { RescheduleSessionApiResponse } from '../models/RescheduleSessionApiResponse';
import type { RescheduleSessionDto } from '../models/RescheduleSessionDto';
import type { SessionDetailApiResponse } from '../models/SessionDetailApiResponse';
import type { UpdateSessionNotesApiResponse } from '../models/UpdateSessionNotesApiResponse';
import type { UpdateSessionNotesDto } from '../models/UpdateSessionNotesDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpertAppSessionsService {
    /**
     * List expert clients with session info
     * Returns clients the expert has sessions with. Filter by tab (active/inactive), booking type (package/single_session), and optional session scheduled date (UTC day).
     * @param tab Filter by tab: active clients or inactive clients
     * @param type Filter by booking type: package or single_session
     * @param search Search by client name
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @param subServiceId Filter by sub-service UUID
     * @param mode Filter by session mode
     * @param sortBy Sort order for clients list
     * @param dayStartUtc Start of the day range as a full ISO-8601 UTC timestamp. For a local day view, send local midnight converted to UTC.
     * @param dayEndUtc End of the day range (exclusive) as a full ISO-8601 UTC timestamp.
     * @returns FetchExpertClientsApiResponse Clients fetched successfully
     * @throws ApiError
     */
    public static expertSessionsControllerFetchExpertClientsV1(
        tab: 'active' | 'inactive' = 'active',
        type?: 'package' | 'single_session',
        search?: string,
        page: number = 1,
        pageSize: number = 10,
        subServiceId?: string,
        mode?: 'online' | 'client_location' | 'expert_location',
        sortBy: 'relevance' | 'distance' = 'relevance',
        dayStartUtc?: string,
        dayEndUtc?: string,
    ): CancelablePromise<FetchExpertClientsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/sessions',
            query: {
                'tab': tab,
                'type': type,
                'search': search,
                'page': page,
                'pageSize': pageSize,
                'subServiceId': subServiceId,
                'mode': mode,
                'sortBy': sortBy,
                'dayStartUtc': dayStartUtc,
                'dayEndUtc': dayEndUtc,
            },
        });
    }
    /**
     * List sessions for a specific client
     * Returns all sessions between the expert and the specified client, including client contact details (phone country code and phone number). Optionally filter by session status.
     * @param clientId Client UUID
     * @param status Filter by session status (comma-separated)
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns FetchClientSessionsApiResponse Sessions fetched successfully
     * @throws ApiError
     */
    public static expertSessionsControllerFetchClientSessionsV1(
        clientId: string,
        status?: Array<'scheduled' | 'in_progress' | 'completed' | 'cancelled' | 'rescheduled'>,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<FetchClientSessionsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/sessions/clients/{clientId}',
            path: {
                'clientId': clientId,
            },
            query: {
                'status': status,
                'page': page,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Get session detail
     * Returns full session detail including client info, booking/package details, location, service, and latest reschedule request.
     * @param sessionId Session UUID
     * @returns SessionDetailApiResponse Session detail fetched successfully
     * @throws ApiError
     */
    public static expertSessionsControllerGetSessionDetailV1(
        sessionId: string,
    ): CancelablePromise<SessionDetailApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/sessions/{sessionId}',
            path: {
                'sessionId': sessionId,
            },
            errors: {
                404: `Session not found`,
            },
        });
    }
    /**
     * Get booking/package detail
     * Returns full booking detail including package info, all sessions, client details (including phone country code and phone number), service, and location.
     * @param bookingId Booking UUID
     * @returns BookingDetailApiResponse Booking detail fetched successfully
     * @throws ApiError
     */
    public static expertSessionsControllerGetBookingDetailV1(
        bookingId: string,
    ): CancelablePromise<BookingDetailApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/sessions/bookings/{bookingId}',
            path: {
                'bookingId': bookingId,
            },
            errors: {
                404: `Booking not found`,
            },
        });
    }
    /**
     * Mark attendance for a session
     * Expert marks attendance on a scheduled or in-progress session only after the scheduled end time has passed. Optionally include session notes.
     * @param sessionId Session UUID
     * @param requestBody
     * @returns MarkAttendanceApiResponse Attendance marked successfully
     * @throws ApiError
     */
    public static expertSessionsControllerMarkAttendanceV1(
        sessionId: string,
        requestBody: MarkAttendanceDto,
    ): CancelablePromise<MarkAttendanceApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/expert-app/sessions/{sessionId}/attendance',
            path: {
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid session state or session has not ended yet`,
                404: `Session not found`,
            },
        });
    }
    /**
     * Add or update session notes
     * Expert adds or updates notes on any session they own.
     * @param sessionId Session UUID
     * @param requestBody
     * @returns UpdateSessionNotesApiResponse Session notes updated successfully
     * @throws ApiError
     */
    public static expertSessionsControllerUpdateSessionNotesV1(
        sessionId: string,
        requestBody: UpdateSessionNotesDto,
    ): CancelablePromise<UpdateSessionNotesApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/expert-app/sessions/{sessionId}/notes',
            path: {
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Session not found`,
            },
        });
    }
    /**
     * Request to reschedule a session
     * Expert requests a reschedule for a scheduled session. The client will be notified and can pick a new time.
     * @param sessionId Session UUID
     * @param requestBody
     * @returns RescheduleSessionApiResponse Reschedule request submitted successfully
     * @throws ApiError
     */
    public static expertSessionsControllerRescheduleSessionV1(
        sessionId: string,
        requestBody: RescheduleSessionDto,
    ): CancelablePromise<RescheduleSessionApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/sessions/{sessionId}/reschedule',
            path: {
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid session state for reschedule`,
                404: `Session not found`,
            },
        });
    }
    /**
     * Cancel a single session
     * Expert cancels a scheduled session. The client will be notified about the cancellation.
     * @param sessionId Session UUID
     * @param requestBody
     * @returns CancelSessionApiResponse Session cancelled successfully
     * @throws ApiError
     */
    public static expertSessionsControllerCancelSessionV1(
        sessionId: string,
        requestBody: CancelSessionDto,
    ): CancelablePromise<CancelSessionApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/sessions/{sessionId}/cancel',
            path: {
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid session state for cancellation`,
                404: `Session not found`,
            },
        });
    }
    /**
     * Cancel entire package/booking
     * Expert cancels the entire booking and all remaining scheduled sessions within it.
     * @param bookingId Booking UUID
     * @param requestBody
     * @returns CancelBookingApiResponse Booking cancelled successfully
     * @throws ApiError
     */
    public static expertSessionsControllerCancelBookingV1(
        bookingId: string,
        requestBody: CancelBookingDto,
    ): CancelablePromise<CancelBookingApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/sessions/bookings/{bookingId}/cancel',
            path: {
                'bookingId': bookingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid booking state for cancellation`,
                404: `Booking not found`,
            },
        });
    }
    /**
     * Create a followup plan from a session
     * Expert proposes additional sessions to the client (used for psychologist package creation and requesting more sessions). The client can accept or decline.
     * @param sessionId Session UUID
     * @param requestBody
     * @returns CreateFollowupApiResponse Followup plan created successfully
     * @throws ApiError
     */
    public static expertSessionsControllerCreateFollowupV1(
        sessionId: string,
        requestBody: CreateFollowupDto,
    ): CancelablePromise<CreateFollowupApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/sessions/{sessionId}/followup',
            path: {
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid session state for followup`,
                404: `Session not found`,
            },
        });
    }
}
